module.exports = __webpack_public_path__ + "images/consent_pending1_5bf342a.png";